import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-move-in-array-arrows',
  templateUrl: './move-in-array-arrows.component.html',
  styleUrls: ['./move-in-array-arrows.component.scss']
})
export class MoveInArrayArrowsComponent implements OnInit {

  @Input() enabledUp: boolean;
  @Input() enabledDown: boolean;
  @Output() changePosition = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  public changePositionClicked(up: boolean): void {
    this.changePosition.emit(up);
  }
}
